module.exports = __webpack_public_path__ + "static/img/faq_service02.b24e558.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/faq_service02.png
// module id = hhHD
// module chunks = 2